/*global ga _gaq dataLayer _satellite */

// TODO: Dynamic Yield Remove
//import { DynamicYieldAddToBagEvent } from "../dynamic-yield/dynamic-yield";

import { getCookie } from "@remarkablenet/rcm-utils";

export const dispatchEventWrapper = (el, name, data) => {
    const evt = new CustomEvent(name, {
        detail: data,
        bubbles: true
    });
    el.dispatchEvent(evt);
};

export const listenEvents = () => {

    (document.querySelectorAll(`[href^="tel:"]`)as NodeListOf<HTMLAnchorElement>)
        .forEach(elm => {
            elm.addEventListener('click', () => {
                var phoneNumber = /^tel:(.*)/.exec(elm.href);
                if (phoneNumber.length > 1) {
                    window.dataLayer.push({
                        'page_action': 'telephone_click',
                        'page_telephone_number': phoneNumber
                    });
                }
            });
        });

    document.addEventListener('rc-filter-opened', (eventData: any) => track(eventData.detail));
    document.addEventListener('rc-filter-clicked', (eventData: any) => {
        track(eventData.detail);
    });
    document.addEventListener('rc-category-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-pageview', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-track-link', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-signup-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-menu-link-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-footer-link-clicked', (eventData:any) => track(eventData.detail));
    document.addEventListener('rc-add-to-bag-clicked', (eventData: any) => {

        track(eventData.detail[0], { dataLayerPush: true });

        // TODO: Dynamic Yield Remove
        //DynamicYieldAddToBagEvent(eventData.detail[0]);

    });

    document.addEventListener('rc-form-submit', (eventData:any) => track(eventData.detail));
}; 

const track = (eventdata:any, options = null) => {
    gaTrack(eventdata);
    if (options) {
        if (options.dataLayerPush) {
            window.dataLayer.push({
                event: 'add to bag',
                addToBag: eventdata
            });
        }
    }
};

const gaTrack = (eventData:any) => {
    const defaultData = {
        area: '',
        event: '',
        value: '',
        value2: undefined
    };
    const data = Object.assign(defaultData, eventData);

    if (document.location.hostname === "localhost" || document.location.hostname.indexOf('remarkable') > 0) {
        console.groupCollapsed('Tracking event fired');
        console.log(data);
        console.log(event);
        console.groupEnd();
    }

    try {
        if (typeof window.ga !== "undefined") {
            window.ga('send', 'event', data.area, data.event, data.value, data.value2);
        }
        else if (typeof window._gaq !== 'undefined') {
            window._gaq.push([
                '_trackEvent',
                data.area,
                data.event,
                data.value,
                data.value2
            ]);
        } else {
            throw 'Analytics not installed';
        }
    } catch (e) {
        console.error(e);
    }
};